import { onBeforeUnmount, onMounted, ref } from 'vue';

// The app nav is position:fixed, so .leanlaw-main reserves no space for it and a
// `top: 0` sticky element lands behind it. <header-component> itself is a
// zero-height wrapper; the rendered height is the nested .header's, measured live.
const NAVBAR_SELECTOR = 'header-component .header';

/** Live height of the fixed app nav, for use as a sticky element's `top` offset. */
export function useNavbarHeight() {
  const navbarHeight = ref(0);
  let observer: ResizeObserver | null = null;

  const measure = () => {
    navbarHeight.value = document.querySelector(NAVBAR_SELECTOR)?.getBoundingClientRect().height ?? 0;
  };

  onMounted(() => {
    measure();
    const navbar = document.querySelector(NAVBAR_SELECTOR);
    if (navbar) {
      observer = new ResizeObserver(measure);
      observer.observe(navbar);
    }
  });

  onBeforeUnmount(() => observer?.disconnect());

  return navbarHeight;
}
